import { render } from "./ValidatorListItem.vue?vue&type=template&id=608167c1"
import script from "./ValidatorListItem.vue?vue&type=script&lang=ts"
export * from "./ValidatorListItem.vue?vue&type=script&lang=ts"
script.render = render

export default script